import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { theme } from '../adminTheme';

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const activeStyle = { color: theme.accent, fontWeight: 600 };

  return (
    <nav style={styles.nav}>
      <div>
        <NavLink to="/" style={{ fontWeight: 700, marginRight: 20, textDecoration: 'none', color: theme.text, fontSize: '1.1rem' }}>
          Sumabit
        </NavLink>
        <NavLink to="/admin/dashboard" style={styles.link} className={({ isActive }) => isActive ? activeStyle : undefined}>Dashboard</NavLink>
        <NavLink to="/admin/users" style={styles.link} className={({ isActive }) => isActive ? activeStyle : undefined}>Usuarios</NavLink>
        <NavLink to="/admin/invoices" style={styles.link} className={({ isActive }) => isActive ? activeStyle : undefined}>Facturas</NavLink>
        <NavLink to="/admin/unpaid" style={styles.link} className={({ isActive }) => isActive ? activeStyle : undefined}>Impagos</NavLink>
        <NavLink to="/admin/settings" style={styles.link} className={({ isActive }) => isActive ? activeStyle : undefined}>Config</NavLink>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ color: theme.textMuted, fontSize: '0.85rem' }}>{user?.email}</span>
        <button onClick={handleLogout} style={styles.logoutBtn}>Cerrar Sesión</button>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.card,
  },
  link: {
    marginRight: 14,
    textDecoration: 'none',
    color: theme.textMuted,
    fontSize: '0.9rem',
  },
  logoutBtn: {
    padding: '6px 14px',
    border: `1px solid ${theme.border}`,
    borderRadius: '6px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontSize: '0.85rem',
    color: theme.textMuted,
  },
};
